/* ===== main.tsx — نقطة الدخول الوحيدة (index.html) =====
   تطبيق صفحة واحدة بعناوين نظيفة: الموجِّه (app/pageRouter.ts) يختار الصفحة من
   المسار — ‎/login‎ · ‎/sign?t=…‎ · والتطبيق لكل ما سواهما — ويحمّل وحدتها كسولاً،
   ويركّب أنماطها وعنوانها وسماتها (app/pageShell.ts) ثم يرسمها في الجذر الواحد.
   كانت هنا ثلاث نقاط دخول لثلاث صفحات HTML (التطبيق · الدخول · التوقيع).

   لا CSS يُستورد هنا ولا في أي مكان استيراداً عادياً: كل صفحة تركّب أوراقها بنفسها
   وتزيلها عند مغادرتها — انظر pageShell.ts. */

import { createPageRouter } from '@/app/pageRouter';

const host = document.getElementById('root');
if (!host) throw new Error('#root غير موجود في index.html');

void createPageRouter({
  host,
  loaders: {
    app: () => import('@/app/pages/appPage'),
    login: () => import('@/app/pages/loginPage'),
    sign: () => import('@/app/pages/signPage'),
  },
}).start();
